'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LoginRoutes;

var _loginTpl = require('./login.tpl.html');

var _loginTpl2 = _interopRequireDefault(_loginTpl);

var _resetPasswordTpl = require('./reset-password.tpl.html');

var _resetPasswordTpl2 = _interopRequireDefault(_resetPasswordTpl);

var _resetPasswordRequestTpl = require('./reset-password-request.tpl.html');

var _resetPasswordRequestTpl2 = _interopRequireDefault(_resetPasswordRequestTpl);

var _createPasswordTpl = require('./create-password.tpl.html');

var _createPasswordTpl2 = _interopRequireDefault(_createPasswordTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

function LoginRoutes($stateProvider) {
    $stateProvider.state('login', {
        url: '/login',
        module: 'public',
        views: {
            "@": {
                controller: 'LoginController',
                controllerAs: 'vm',
                templateUrl: _loginTpl2.default
            }
        },
        data: {
            pageTitle: 'login.login'
        }
    }).state('login.resetPasswordRequest', {
        url: '/resetPasswordRequest',
        module: 'public',
        views: {
            "@": {
                controller: 'ResetPasswordRequestController',
                controllerAs: 'vm',
                templateUrl: _resetPasswordRequestTpl2.default
            }
        },
        data: {
            pageTitle: 'login.request-password-reset'
        }
    }).state('login.resetPassword', {
        url: '/resetPassword?resetToken',
        module: 'public',
        views: {
            "@": {
                controller: 'ResetPasswordController',
                controllerAs: 'vm',
                templateUrl: _resetPasswordTpl2.default
            }
        },
        data: {
            pageTitle: 'login.reset-password'
        }
    }).state('login.createPassword', {
        url: '/createPassword?activateToken',
        module: 'public',
        views: {
            "@": {
                controller: 'CreatePasswordController',
                controllerAs: 'vm',
                templateUrl: _createPasswordTpl2.default
            }
        },
        data: {
            pageTitle: 'login.create-password'
        }
    });
}


// WEBPACK FOOTER //
// ./src/app/login/login.routes.js